import {
    undef,
    allowFieldAutoProgress,
    allowInputFieldErrorHighlighting
} from './';

function getFormattedDate(date) {
    return date.toISOString().slice(0, 10);
}

function getNightsCount(checkIn, checkOut) {
    const checkInDate = new Date(checkIn).setHours(0, 0, 0, 0);
    const checkOutDate = new Date(checkOut).setHours(0, 0, 0, 0);

    return Math.round((checkOutDate - checkInDate) / (24 * 60 * 60 * 1000));
}

function hasEmptyDate(date) {
    return !date;
}

function hasEmptyDates(startDate, endDate) {
    return hasEmptyDate(startDate) && hasEmptyDate(endDate);
}

function hasEmptyDatesValues({startDate, endDate}) {
    return hasEmptyDates(startDate, endDate);
}

function hasFilledDate(date) {
    return !hasEmptyDate(date);
}

function hasFilledDates(startDate, endDate) {
    return hasFilledDate(startDate) && hasFilledDate(endDate);
}

function hasFilledDatesValues({startDate, endDate}) {
    return hasFilledDates(startDate, endDate);
}

function hasPartialDates(startDate, endDate) {
    return !hasEmptyDates(startDate, endDate) && !hasFilledDates(startDate, endDate);
}

function hasPartialDatesValues({startDate, endDate}) {
    return hasPartialDates(startDate, endDate);
}

function hasValidDate(date) {
    return hasFilledDate(date);
}

function hasValidDateRange(startDate, endDate) {
    const startTimestamp = Date.parse(startDate);
    const endTimestamp = Date.parse(endDate);

    const todayDate = getFormattedDate(new Date());
    const todayTimestamp = Date.parse(todayDate);

    return (
        startTimestamp >= todayTimestamp &&
        startTimestamp < endTimestamp
    );
}

function hasValidDates(startDate, endDate) {
    return hasValidDate(startDate) && hasValidDate(endDate) && hasValidDateRange(startDate, endDate);
}

function hasValidDatesValues({startDate, endDate}) {
    return hasValidDates(startDate, endDate);
}

function shouldDatesFieldAutoProgressOnClose(media, form, dates) {
    const {
        settings: {
            isMobile
        }
    } = media;

    const {
        latestValues
    } = dates;

    return (
        isMobile &&
        allowFieldAutoProgress(form, dates) &&
        hasFilledDatesValues(latestValues)
    );
}

function shouldDatesFieldAutoProgressOnSubmit(media, form, dates) {
    const {
        settings: {
            isMobile
        }
    } = media;

    const {
        latestValues
    } = dates;

    // TODO: Fix on SHCMP-430
    /* istanbul ignore next */
    return (
        !isMobile &&
        allowFieldAutoProgress(form, dates) &&
        hasFilledDatesValues(latestValues)
    );
}

function shouldDatesFieldNotAutoProgressOnCancel(media, form, dates) {
    const {
        settings: {
            isMobile
        }
    } = media;

    return (
        isMobile &&
        allowFieldAutoProgress(form, dates)
    );
}

function showDatesInputFieldError(media, form, dates) {
    const {
        settings: {
            isMobile
        }
    } = media;

    const {
        latestValues
    } = dates;

    return !isMobile && (
        allowInputFieldErrorHighlighting(form, dates) && !hasValidDatesValues(latestValues)
    );
}

function showDatesInputIcon(form, dates, id) {
    const showInputIconKey = `showInputIcon${id}`;

    const {
        options: {
            showIcons
        }
    } = form;

    const {
        options: {
            [showInputIconKey]: showInputIcon
        }
    } = dates;

    return (
        showInputIcon ||
        showIcons && showInputIcon === undef
    );
}

function showDatesInputIcon1(form, dates) {
    return showDatesInputIcon(form, dates, 1);
}

function showDatesInputIcon2(form, dates) {
    return showDatesInputIcon(form, dates, 2);
}

export {
    getFormattedDate,
    getNightsCount,
    hasEmptyDate,
    hasEmptyDates,
    hasEmptyDatesValues,
    hasFilledDate,
    hasFilledDates,
    hasFilledDatesValues,
    hasPartialDates,
    hasPartialDatesValues,
    hasValidDate,
    hasValidDateRange,
    hasValidDates,
    hasValidDatesValues,
    shouldDatesFieldAutoProgressOnClose,
    shouldDatesFieldAutoProgressOnSubmit,
    shouldDatesFieldNotAutoProgressOnCancel,
    showDatesInputFieldError,
    showDatesInputIcon,
    showDatesInputIcon1,
    showDatesInputIcon2
};
